import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1676337864622'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='13612'
    >
        <path
            d='M512 1024C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z m-114.176-310.954667a53.333333 53.333333 0 0 0 75.434667 0l323.328-323.328a53.333333 53.333333 0 1 0-75.434667-75.434666l-287.914667 283.306666-128.853333-128.853333a53.333333 53.333333 0 1 0-75.434667 75.434667l168.874667 168.874666z'
            fill='currentColor'
            p-id='13613'
        ></path>
    </svg>
)

export const PostIcon = props => <Icon component={SVG} {...props} />